import { render, staticRenderFns } from "./project-data.vue?vue&type=template&id=f42cedce&scoped=true&"
import script from "./project-data.vue?vue&type=script&lang=js&"
export * from "./project-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42cedce",
  null
  
)

export default component.exports